import { render, staticRenderFns } from "./MobileTestScreen.vue?vue&type=template&id=0196c9be&scoped=true&"
import script from "./MobileTestScreen.vue?vue&type=script&lang=js&"
export * from "./MobileTestScreen.vue?vue&type=script&lang=js&"
import style0 from "./MobileTestScreen.vue?vue&type=style&index=0&id=0196c9be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0196c9be",
  null
  
)

export default component.exports